import './option.scss';
import {useEffect, useRef, useState} from 'react';
import {useLayoutContext} from '../../context/game';
import Badge from '../../components/badge';
export default function Match({count,setRoute}){
	const [context,setContext] = useLayoutContext();
	const matches = window['game_data']?.matches || {};
	const game_cards = window['game_data']?.cards;
	const match_colors = window['game_data']?.colors || {};
	const cards = Object.keys(matches || {})?.reduce((agr,matchId)=>{
		const card_arr = [];
		const match = matches[matchId]
		match.cards?.forEach((cardId)=>{
			const {text} = game_cards[cardId] 
			const color = match_colors[matchId];
			card_arr.push({
				cardId,
				matchId,
				text,
				color,
			})
		})
		return [...agr,...card_arr]
	},[])

	let shuffle = cards?.sort(() => Math.random() - .5).sort(() => Math.random() - .5);
	let nwo = useRef(shuffle);
	const [selected,setSelected] = useState([]);
	const [highlighted,setHighlighted] = useState([]);
	const [hidden, setHidden] = useState([]);
	const [wrong, setWrong] = useState([]);
	useEffect(()=>{
		if(selected.length < 2) return;

		const [match1,match2] = selected;

		if(match1 === match2){
			const cardIds = matches[match1]?.cards
			setTimeout(()=>{
				setHidden([...hidden,...cardIds]);
			},500)
		} else {
			setSelected([])
			setWrong([...highlighted]);
			setTimeout(()=>{
				setWrong([]);
				setHighlighted([])
			},1000)
		}
	},[selected.length,highlighted.length]);
	useEffect(()=>{
		setSelected([])
		setHighlighted([])
		setContext({hidden})
	},[hidden.length])

	useEffect(()=>{
		if(context?.reset === false) return;
		if(context?.reset === true) {
			nwo.current = nwo.current.sort(() => Math.random() - .5)
			setHighlighted([]);
			setSelected([]);
			setHidden([]);
			setContext({reset:false,hidden:[]})
		}
	},[context?.reset])

	useEffect(()=>{
		if(!hidden.length) return;
		if(hidden.length / 2 === Object.keys(matches).length){
			setTimeout(()=>{
				setRoute('title');
			},1500)
		}
	},[hidden.length])
	const {statement} = window['game_data'];
	return(<>
		<div className="position-relative flex-grow-1">
			<div className="game-bg"></div>
			<div className="container py-5 z-1 position-relative">
				{statement && (<div className="mb-5 text-center">
					<Badge className='d-inline-block fw-600 heads'>
						{statement}
					</Badge>
				</div>)}
				<div className="row justify-content-center">
						{nwo.current?.map(({cardId,matchId,color,text})=>{
							const state = [];
							highlighted.includes(cardId) && state.push('--highlighted');
							hidden.includes(cardId) && state.push('--hidden');
							wrong.includes(cardId) && state.push('--wrong')
							return(
								<div className="col-xl-3 col-lg-4 col-md-6 mb-3" key={cardId}>
									<div
										className={`option h-100 ${state.join(' ')}`}
										style={{'--option-bg':color || '#fff'}}
										onClick={()=>{
											if(hidden.includes(cardId)) return;
											if(highlighted.length >= 2) return;
											if(highlighted.includes(cardId)){
												setHighlighted([]);
												setSelected([]);
												return;
											}
											setSelected([...selected,matchId]);
											setHighlighted([...highlighted,cardId]);
										}}
									>
										{text}
									</div>
								</div>
							)
						})}
				</div>
			</div>
		</div>
	</>)
}